import { Grid, TextField, Typography } from "@mui/material";
import Box from '@mui/material/Box';
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "../context";
import { useWindowDimensions } from '../hooks/useWindowDimensions';
import { Padlock } from '../images/padlock';
import { getCardBrand } from '../services/utils';
import AlertField from './Alert';
import { PrimaryButton } from './PrimaryButton';
import { SelectMonth } from "./SelecMonth";

// const StyledSVG = styled.svg`
//   width: 50px;
//   height: 50px;
//   background-color: ${(props) => props.color};
//   background-image: url(${(props) => props.src});
// `;

export const CardForm = () => {
    const { lead, checkout, subscribed, plan } = useContext<any>(AppContext);
    const history = useHistory();
    const [openAlert, setOpenAlert] = useState<boolean>(false)
    const [alertMessage, setAlertMessage] = useState<string>('')
    const [openDialog, setOpenDialog] = useState(false);
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const { width } = useWindowDimensions();
    useEffect(() => {
      console.log(lead)
    }, [])

    const brandOptions = [
      {value: 'Visa', label: 'Visa'},
      {value: 'Master', label: 'Master'},
      {value: 'Amex', label: 'Amex'},
      {value: 'Elo', label: 'Elo'},
      {value: 'Aura', label: 'Aura'},
      {value: 'JCB', label: 'JCB'},
      {value: 'Diners', label: 'Diners'},
      {value: 'Diners', label: 'Discover'},
      {value: 'Diners', label: 'Hipercard'},
    ]
    const monthOptions = [
      {value: '01', label: 'Janeiro'},
      {value: '02', label: 'Fevereiro'},
      {value: '03', label: 'Março'},
      {value: '04', label: 'Abril'},
      {value: '05', label: 'Maio'},
      {value: '06', label: 'Junho'},
      {value: '07', label: 'Julho'},
      {value: '08', label: 'Agosto'},
      {value: '09', label: 'Setembro'},
      {value: '10', label: 'Outubro'},
      {value: '11', label: 'Novembro'},
      {value: '12', label: 'Dezembro'},
    ]
    const yearOptions = [
      {value: '2022', label: '2022'},
      {value: '2023', label: '2023'},
      {value: '2024', label: '2024'},
      {value: '2025', label: '2025'},
      {value: '2026', label: '2026'},
      {value: '2027', label: '2027'},
      {value: '2028', label: '2028'},
      {value: '2029', label: '2029'},
      {value: '2030', label: '2030'},
      {value: '2031', label: '2031'},
      {value: '2032', label: '2032'},
      {value: '2033', label: '2033'},
      {value: '2034', label: '2034'},
      {value: '2035', label: '2035'},
      {value: '2036', label: '2036'},
      {value: '2037', label: '2037'},
      {value: '2038', label: '2038'},
      {value: '2039', label: '2039'},
      {value: '2040', label: '2040'},
      {value: '2041', label: '2041'},
      {value: '2042', label: '2042'},
      {value: '2043', label: '2043'},
      {value: '2044', label: '2044'},
      {value: '2045', label: '2045'},
      {value: '2046', label: '2046'},
      {value: '2047', label: '2047'},
    ]
    const handleYear = (value: any) => {
      setYear(value)
    }
    const handleMonth = (value: any) => {
      setMonth(value)
    }
    const handleChangeInput = (e: any) => {
      const { maxLength, value, name } = e.target;
      const [fieldName, fieldIndex] = name.split("_")
      let fieldIntIndex = parseInt(fieldIndex)
      if (value.length === maxLength) {
          const nextfield = document.querySelector<HTMLInputElement>(
            `input[name=number_${fieldIntIndex + 1}]`);
            console.log(nextfield)
            if (nextfield !== null) {
              console.log(4)
              nextfield.focus();
          }
    }
  }
     
    const handleClose = () => {
      setOpenAlert(false)
    }

    const handleCloseDialog = () => {
      setOpenDialog(false);
    };

    
    const handleClick = async (e: any) => {
    e.preventDefault();
      console.log(lead)
    const cardNumber = 
        e.target.number_1.value 
      + e.target.number_2.value 
      + e.target.number_3.value 
      + e.target.number_4.value
    const cardExpiry = month + "/" + year
    
      const metaData = {
        cpf: lead.cpf.replace(/\D/g, ""),
        leadId: lead.leadId,
        amount: lead.product_value,
        cardNumber: cardNumber,
        cardName: e.target?.cardName.value,
        cardSecurity: e.target?.cvc.value,
        cardExpiry: cardExpiry,
        cardBrand: getCardBrand(cardNumber)
      }
      
      console.log(metaData)
      if (!metaData.cardNumber) {
        setAlertMessage('Número não informado!')
        setOpenAlert(true)
      } else if (!metaData.cardName) {
        setAlertMessage('Nome do titular não informado!')
        setOpenAlert(true)
      } else if (!metaData.cardSecurity) {
        setAlertMessage('CVC não informado!')
        setOpenAlert(true)
      } else if (!metaData.cardExpiry) {
        setAlertMessage('Validade não informado!')
        setOpenAlert(true)
      } else {
        console.log(metaData.cardBrand)
        console.log(metaData)
        const res = await checkout(metaData)
        if (res.success) {
          await subscribed(lead.leadId)
          history.push('/sucesso')
        } 
        if (!res.success)  {
          history.push('/falha')
        }
      }
    }

    return (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '0px',
          backgroundColor: "background.default",
          mx: 'auto',}}> 
        <form onSubmit={handleClick} >
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <AlertField message={alertMessage} status={openAlert} handle={handleClose} />
        </Box>
        <Box sx={{
          my: width > 375 ? 2 : 0,
          mb: 2,
          px: '0.3rem',
          maxWidth: width > 375 ? 450 : 375,
          border: 2,
          borderColor: 'primary.main',
          borderRadius: 3,
          position: 'relative'
        }}>
        <Grid container sx={{ px: width > 375 ? 5 : 1, py: width > 375 ? 5 : 2}}  rowSpacing={0.1} spacing={1}>
         
          <Grid item xs={12} sm={12}>
          <Box  sx={{position: 'absolute', right: 20, top: 8}}>
         <Padlock />
          </Box>
          <Box  sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column'}}>
            <Typography sx={{fontSize: '0.8rem', color: "#656565"}}>
              Número do cartão
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', ml: 0}}>
            <TextField 
            onChange={(e: any) => handleChangeInput(e)}
            sx={{mr:0.5, backgroundColor:'lightgray'}} 
            size='small' 
            inputProps={{ inputMode: 'numeric', maxLength: 4 }} 
            id="number_1"
            name="number_1"
            variant="outlined" />
            <TextField
            onChange={(e: any) => handleChangeInput(e)} 
            sx={{mx:0.5, backgroundColor:'lightgray'}} 
            size='small' 
            inputProps={{ inputMode: 'numeric', maxLength: 4 }} 
            id="number_2"
            name="number_2"
            variant="outlined" />
            <TextField
            onChange={(e: any) => handleChangeInput(e)} 
            sx={{mx:0.5, backgroundColor:'lightgray'}} 
            size='small' 
            inputProps={{ inputMode: 'numeric', maxLength: 4 }} 
            id="number_3"
            name="number_3"
            variant="outlined" />
            <TextField 
            sx={{mx:0.5, backgroundColor:'lightgray'}} 
            size='small' 
            inputProps={{ inputMode: 'numeric', maxLength: 6 }} 
            id="number_4"
            name="number_4"
            variant="outlined" />
            </Box>
          </Box>
          </Grid>
          <Grid item xs={12} sm={12}>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end'}}>
          <TextField 
            fullWidth
            color="secondary" 
            id='cardName'
            label='Nome Conforme Cartão'
            variant="standard" 
            size='small'
            />
          </Box>
          </Grid>
          <Grid item xs={6} sm={4}>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end'}}>
            <SelectMonth id='month' label='Mês' options={monthOptions} handleClick={handleMonth} />
          </Box>
          </Grid>
          <Grid item xs={6} sm={4}>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end'}}>
          <SelectMonth id='year' label='Ano' options={yearOptions} handleClick={handleYear} />
          </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end'}}>
          <TextField 
            fullWidth
            color="secondary" 
            id='cvc'
            label='CVV'
            variant="standard" 
            size='small'
            />
          </Box>
          </Grid>
          </Grid>
          </Box>
          <Box  sx={{ display: 'flex', alignItems: 'flex-end' }}>
            <PrimaryButton name='Contratar' />
          </Box>
          </form>
        </Box>
    )
}
